// Libraries
import { ReactElement } from 'react';

// Styles
import styles from './GameStats.module.css';

/**
 * @function GameStats
 * Provides a container for current game information
 *
 * @example
 * return (
 *   <GameStats></GameStats>
 * )
 */
function GameStats({ children }: GameStatsProps): JSX.Element {
    return <section className={styles.container}>{children}</section>;
}

/**
 * @interface GameStats
 * Describes the properties required for the GameStats component
 *
 * @property {ReactElement} children List of game data elements
 */
export interface GameStatsProps {
    children?: ReactElement[];
}

// Exports
export default GameStats;
